import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "password_32",
  "use": "password_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"password_32\"><path d=\"M21 2a9 9 0 00-9 9 8.87 8.87 0 00.39 2.61L2 24v6h6l10.39-10.39A9 9 0 0030 11.74a8.77 8.77 0 00-1.65-6A9 9 0 0021 2zm0 16a7 7 0 01-2-.3l-1.15-.35-.85.85-3.18 3.18L12.41 20 11 21.41l1.38 1.38-1.59 1.59L9.41 23 8 24.41l1.38 1.38L7.17 28H4v-3.17L13.8 15l.85-.85-.29-.95a7.14 7.14 0 013.4-8.44 7 7 0 0110.24 6 6.69 6.69 0 01-1.09 4A7 7 0 0121 18z\" /><circle cx=\"22\" cy=\"10\" r=\"2\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol